export default __webpack_public_path__ + "static/media/previous_section.fe20dbc7.svg";